module.exports = __webpack_public_path__ + "img/L3_Frame.bf7cfeca.svg";